function InitDatePickerLinear(model) {
    var container = $("#" + model.pickerId + "-container");

    var gregcal = $.calendars.instance('gregorian', 'en');
    var perscal = $.calendars.instance('persian', 'fa');

    var cyear = container.find("#" + model.pickerId + "_year");
    var cmonth = container.find("#" + model.pickerId + "_month");
    var cday = container.find("#" + model.pickerId + "_day");

    var pmonths = ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دي", "بهمن", "اسفند"];
    var gmonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var lmonths = (model.calendar === "persian") ? pmonths : gmonths;

    cyear.attr('placeholder', (model.calendar === "persian") ? "سال" : "year");
    cmonth.append($('<option>', { value: "", text: (model.calendar === "persian") ? "ماه" : "month" }));
    cday.attr('placeholder', (model.calendar === "persian") ? "روز" : "day");
    $.each(lmonths,
        function (i, v) {
            cmonth.append($("<option>", { value: i + 1, text: v }
            ));
        });

    var value = model.defaultDateStart;
    if (value) {
        var valueDate = xparseDate(value, gregcal);
        var valueConverted = null;
        if (model.calendar === "persian") {
            valueConverted = xconvertDate(valueDate, gregcal, perscal);
        } else {
            valueConverted = valueDate;
        }
        cyear.val(valueConverted.year());
        cmonth.val(valueConverted.month());
        cday.val(valueConverted.day());
    }

    container
        .find("input, select")
        .ready(function (obj) {
            onCalendarDomInit(model, $(this));
        })
        .on("input", function (obj) {
            onCalendarDomInit(model, $(this));
        });

}
function IsWeekend(date) {
    var weekends =[];

    var result = false;
    $.each(weekends,
        function (i, v) {
            var vArray = v.split("-");
            var weekend = { year: parseInt(vArray[0]), month: parseInt(vArray[1]), day: parseInt(vArray[2]) };
            if (date.day() == weekend.day && date.month() == weekend.month && date.year() == weekend.year) {
                result = true;
                return false;
            }
        }
    );
    return result;
}
function loadPrices(sourceValue, destinationValue) {
    var localStorageSource = localStorage.getItem("travel-source");
    var localStorageDestination = localStorage.getItem("travel-destination");
    var source = sourceValue == "-" ? (localStorageSource == undefined ? null : (JSON.parse(localStorageSource).content == undefined ? JSON.parse(localStorageSource).value : JSON.parse(localStorageSource).content.value)) : sourceValue;
    var destination = destinationValue == "-" ? (localStorageDestination == undefined ? null : (JSON.parse(localStorageDestination).content == undefined ? JSON.parse(localStorageDestination).value : JSON.parse(localStorageDestination).content.value)) : destinationValue;
    window.flightRoute = null;
    window.flightDictionary = null;

    var flightRoute = `${source}-${destination}`;
    if (flightRoute !== window.flightRoute &&
        source &&
        destination &&
        source !== destination) {
        $.ajax({
            url: '/FlightSearch/GetDatePickerPriceData',
            method: 'POST',
            cache: false,
            dataType: 'json',
            async: true,
            data: { source: source, destination: destination },
            success: function (data) {
                window.flightRoute = flightRoute;
                window.flightDictionary = data;
            },
            error: function (xhr, ajaxOptions, thrownError) {
                xhr.abort();
            }
        });
    }
}
function setPrices() {
    for (var key in window.flightDictionary) 
        setPriceForDayItem(key, window.flightDictionary[key]);
}
function setPriceForDayItem(item, price) {

    var flightIsActive = $("#flight-tab").hasClass("active") || ($("#flight-tab").length == 0 && $("#FlightSearchForm").length != 0);
    var trainIsActive = $("#eligashtDomesticTrainSearchTab").hasClass("active");
    var julianDate = Date.parse(item);
    var shamsiDate = convertJsDateToShamsi(julianDate);
    var gregorianDate = convertJsDateToGregorian(julianDate);
    var result = { price: "", rate: -1 };
    if ((window.flightDictionary && ((flightIsActive) && !trainIsActive)) || $(".l-header__nav-wrapper a[href='/flights/']").hasClass('active') || ($(".l-header__nav-wrapper a.active").length == 0 && mobileAndTabletCheck())) {

        //get price **************
        if (price == 0 || price == null)
            return result;

        //get rate ***************
        var rate = -1;

        //set start and stop date of related month ------------------
        var stopDate, iterationDate;
        stopDate = convertDateToShamsi(gregorianDate);//to clone
        stopDate._day = shamsiDate._month < 7 ? 31 : shamsiDate._month < 12 ? 30 : 29
        stopDate = stopDate.toJSDate();

        iterationDate = convertDateToShamsi(gregorianDate);//to clone
        iterationDate._day = 1;
        iterationDate = iterationDate.toJSDate();
        //obtain average price between start and stop date ----------
        var sum = 0;
        var count = 0;
        var sdplus = 0;
        var sd = 0;

        while (iterationDate <= stopDate) {
            var key = iterationDate.getFullYear() + "-" + (iterationDate.getMonth() + 1).toString().padStart(2, "0") + "-" + iterationDate.getDate().toString().padStart(2, "0");
            var priceStr = window.flightDictionary[key];
            var itemPrice = priceStr ? parseInt(priceStr.replace(",", "")) : 0;

            if (itemPrice > 0) {
                sum += itemPrice;
                count++;
            }
            iterationDate.setDate(iterationDate.getDate() + 1);
        }



        if (count > 0)
            var average = sum / count;


        iterationDate = convertDateToShamsi(gregorianDate);//to clone
        iterationDate._day = 1;
        iterationDate = iterationDate.toJSDate();

        while (iterationDate <= stopDate) {

            var key = iterationDate.getFullYear() + "-" + (iterationDate.getMonth() + 1).toString().padStart(2, "0") + "-" + iterationDate.getDate().toString().padStart(2, "0");
            var priceStr = window.flightDictionary[key];
            var itemPrice = priceStr ? parseInt(priceStr.replace(",", "")) : 0;
            if (itemPrice > 0) {
                sdplus += Math.pow(itemPrice - average, 2);
                count++;
            }

            iterationDate.setDate(iterationDate.getDate() + 1);
        }

        if (average > 0) {
            sd = sdplus / count;
            sd = (Math.sqrt(sd));

            if (((price - average) / sd) <= -0.6) {
                rate = 0;
            } else if (((price - average) / sd) > -0.6 && ((price - average) / sd) <= 0.4) {
                rate = 1;
            }
            else {
                rate = 2;
            }
        }


        result = { price: price, rate: rate };
    }
    var priceClass = result.rate === -1 ? "" : result.rate === 0 ? "price-pill-cheap" : result.rate === 1 ? "price-pill-moderate" : "price-pill-expensive";
    $("#date-" + item).addClass(priceClass);
    $("#date-" + item).siblings(".day-price").removeClass().addClass("price").text(setPriceFormat(price));
}
function setPriceFormat(value) {
    if (value != null)
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return '';
}
function convertJsDateToShamsi(value) {
    var julianDate = convertJsDateToJulianDate(value);

    var convertedDate = $.calendars.instance("persian", "fa").fromJD(julianDate);
    return convertedDate;
};
function convertJsDateToGregorian(value) {
    var julianDate = convertJsDateToJulianDate(value);

    var convertedDate = $.calendars.instance("gregorian", "en").fromJD(julianDate);
    return convertedDate;
};
function convertJsDateToJulianDate(date) {
    return (date.valueOf() / 86400000) + 2440587.5;
};
function convertDate(calenderType, lang, value) {
    var julianDate = value.toJD();
    var convertedDate = $.calendars.instance(calenderType, lang).fromJD(julianDate);
    return convertedDate;
};

function convertDateToShamsi(value) {
    return convertDate("persian", "fa", value);
};

function convertDateToGregorian(value) {
    return convertDate("gregorian", "en", value);
};
function onCalendarDomInit(model, obj) {

    var errorClass = "xerror";
    var container = $("#" + model.pickerId + "-container");

    var gregcal = $.calendars.instance('gregorian', 'en');
    var perscal = $.calendars.instance('persian', 'fa');

    var cyear = container.find("#" + model.pickerId + "_year");
    var cmonth = container.find("#" + model.pickerId + "_month");
    var cday = container.find("#" + model.pickerId + "_day");

    var pmonths = ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دي", "بهمن", "اسفند"];
    var gmonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var lmonths = (model.calendar === "persian") ? pmonths : gmonths;


    obj.val(obj.val().replace(/[^\d]+/g, ''));

    var xyear = cyear.val();
    var xmonth = cmonth.val();
    var xday = cday.val();

    if (xyear !== "" && xmonth !== "" & xday !== "") {
        var xdate = "{year}-{month}-{day}"
            .replace(/{year}/g, xyear)
            .replace(/{month}/g, xmonth)
            .replace(/{day}/g, xday);

        var xgdate, gdate;
        try {
            if (model.calendar === "persian") {
                xgdate = gregcal.fromJD(perscal.parseDate('yyyy-mm-dd', xdate).toJD());

            } else {
                xgdate = gregcal.fromJD(gregcal.parseDate('yyyy-mm-dd', xdate).toJD());
            }
            gdate = xformatDate(xgdate, gregcal);
            //container.addClass(errorClass);
        } catch (e) {

            //container.removeClass(errorClass);
            //error
        }

        var error = false;
        //if (xyear == "" || xmonth == "" || xday == "") {
        //    error = true;
        //}

        if (model.minDate != undefined && model.minDate !== "") {
            var minDate = xparseDate(model.minDate, gregcal);
            error = !(minDate.compareTo(xgdate) <= 0) || error;
        }
        if (model.maxDate != undefined && model.maxDate !== "") {
            var maxDate = xparseDate(model.maxDate, gregcal);
            error = !(maxDate.compareTo(xgdate) >= 0) || error;
        }

        var y105 = gregcal.today().add(-105, 'y');
        error = (xgdate.compareTo(y105) < 0) || error;

        //$([cyear, cmonth, cday]).each(function (i, v) {
        if (error) {
            container.addClass(errorClass);
        } else {
            container.removeClass(errorClass);
        }
        //});

        container.find("#" + model.pickerId).val(gdate);
    } else {
        //$([cyear, cmonth, cday]).each(function (i, v) {
        container.addClass(errorClass);
        //});
    }
}
function xparseDate(date, sourceCal, format) {
    if (format == undefined) format = 'yyyy-mm-dd';
    return sourceCal.parseDate(format, date);
}
function xconvertDate(date, sourceCal, targetCal, format) {
    if (format == undefined) format = 'yyyy-mm-dd';
    return targetCal.fromJD(sourceCal.parseDate(format, sourceCal.formatDate(format, date)).toJD());
}
function xformatDate(date, calendar, format) {
    if (format == undefined) format = 'yyyy-mm-dd';
    return calendar.formatDate(format, date);
}
function xcloneDate(obj, calendar, format) {
    if (format == undefined) format = 'yyyy-mm-dd';
    //calendar.fromJD(.toJD())
    return xparseDate(xformatDate(obj, calendar, format), calendar, format);
}
function xisnull(obj) {
    return (obj == null || obj == undefined || obj == "");
}
